import { serverReducer } from "app/serverReducer";
import NoPeek from "assets/images/icons/nopeek.svg";
import Peek from "assets/images/icons/peek.svg";
import AddToCartButton from "components/AddToCartButton";
import AddonsVPSDropdown from "components/AddonsVPSDropdown";
import BillingCycleOptions from "components/BillingCycleOptions";
import CardWrapper from "components/CardWrapper";
import ServerOptions from "components/ServerOptions";
import PromoKaosTumbler from "components/PromoKaosTumbler";
import {
  addToCart,
  changeProductFromCart,
  addVpsAddons,
  addPromo,
  removeVpsAddons,
  setQueryPromo,
  removePromoCode,
} from "features/common/layouts/cartSlice";
import {
  getProduct,
  selectProduct,
} from "features/common/products/productsSlice";
import { formatIDR, useQuery } from "helpers/utils";
import {
  getAddonsServer,
  getProductsPromoServer,
  getServerByGroup,
} from "features/server/serverSlice";
import { buildProdName, checkPasswordStrength } from "helpers/helper";
import { useCallback, useEffect, useReducer, useRef, useState } from "react";
import { Placeholder, ProgressBar } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import collapseIcon from "../../assets/images/icons/vcollapse.png";
import MainLayouts from "../../layouts/MainLayouts";
// import styles from "../../assets/scss/Vps.module.scss"; // File sudah dihapus
import { useLocation } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { notifyError, notifyWarning, notifySuccess } from "components/ToastMessage";
import { setOrderParams } from "features/common/layouts/cartSlice";





const Server = () => {
  const query = useQuery();
  const location = useLocation();
  const dispatch = useDispatch();
  const firstLoad = useRef(true);
  const snapshotRef = useRef(false);
  const hostnameRef = useRef(null);
  const passwordRef = useRef(null);
  const peekIconRef = useRef(null);
  const addonsRef = useRef(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pid = params.get("pid");
    const billingcycle = params.get("billingcycle");
    dispatch(setOrderParams({ pid, billingcycle }));
  }, [location.search, dispatch]);

  const currentProduct = useSelector(selectProduct);
  const { products: serverProductsGroup, addonsServer } = useSelector(
    (state) => state.server
  ); 
  const { productsList } = useSelector((state) => state.cart);
  const { activeGID, current: activeProd } = currentProduct;
  const currentProdName = activeProd.name;
  const { pid: pidOnCart } = currentProduct.current;
  const [server, setServer] = useState(0);
  const [priceByTermin, setPriceByTermin] = useState(0);
  const [passwordStrength, setPasswordStrength] = useState({
    title: null,
    variant: "danger",
    score: 0,
  });
  const [termin, setTermin] = useState("annually");
  const [serverPid, setServerPid] = useState(null);
  const [currentOS, setCurrentOS] = useState(0);
  const [currentPanel, setCurrentPanel] = useState(false);
  const [currentSupport, setCurrentSupport] = useState(false);
  const [currentSoftaculous, setCurrentSoftaculous] = useState(false);
  const [currentBackup, setCurrentBackup] = useState(false);
  const [currentOthers, setCurrentOthers] = useState(false);
  const [showPromo, setShowPromo] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const { total } = useSelector((state) => state.cart);

  const [serverProduct, setServerProduct] = useReducer(serverReducer, {
    pid: +query.pid || 1145,
    price: {},
    serverDetails: null,
    promo: null,
  });

  const checkControlPanel = addonsServer.filter(
    (item) =>
      item.category === "Software" && item.input_name === "Control Panel"
  );

  const checkSoftaculous = addonsServer.filter(
    (item) => item.category === "Software" && item.input_name === "Softaculous"
  );

  const checkSupportLevel = addonsServer.filter(
    (item) => item.category === "Support-Level"
  );

  const checkAdvancedBackup = addonsServer.filter(
    (item) =>
      item.category === "Backup" &&
      (item.name.endsWith(currentProdName?.substr(0, 4).trim()) ||
        item.name.endsWith("Backup"))
  );

  const checkOthers = addonsServer.filter((item) => item.category === "Others");

  const findProductsGroup = useCallback(() => {
    if (server === 0) return;
    dispatch(getServerByGroup(server !== activeGID ? server : activeGID));
  }, [server, dispatch, activeGID]);

  useEffect(() => {
    findProductsGroup();
  }, [findProductsGroup]);

  useEffect(() => {
    if (activeGID !== 0) {
      setServer(activeGID);
    }
  }, [activeGID]);

  useEffect(() => {
    if (firstLoad.current) {
      if (!query.pid) {
        dispatch(getProduct(serverProduct.pid));
      } else {
        setServerPid(+query?.pid ?? +serverProduct.pid);
      }

      if (query.billingcycle) {
        setTermin(query.billingcycle);
      }
    }
    snapshotRef.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let mount = true;
    if (serverPid && mount) {
      dispatch(getAddonsServer(serverPid));
      dispatch(getProduct(serverPid));
    }

    return () => {
      mount = false;
    };
  }, [dispatch, serverPid]);

  useEffect(() => {
    let isMounted = true;

    if (isMounted && serverProductsGroup.length !== 0) {
      const getProduct = serverProductsGroup[0];

      if (getProduct?.pid) {
        setServerProduct({ type: "SET_CURRENT_PID", payload: getProduct?.pid });
        setServerPid(getProduct?.pid);
      }

      snapshotRef.current = false;
    }

    return () => (isMounted = false);
  }, [serverProductsGroup, dispatch, currentProdName]);

  useEffect(() => {
    if (serverProductsGroup.length > 0) {
      serverProductsGroup.forEach((prods) => {
        if (serverProduct.pid === prods.pid) {
          setServerProduct({
            type: "SET_PRODUCT_PRICE",
            payload: prods.pricing.IDR,
          });
          setServerProduct({
            type: "SET_PRODUCT_DETAIL",
            payload: {
              pid: prods.pid,
              gid: prods.gid,
              name: prods.name,
              type: prods.type,
              billingcycle: termin,
              price: +priceByTermin,
            },
          });
          if (prods.promo) {
            setServerProduct({
              type: "SET_PROMO",
              payload: {
                pid: prods.pid,
                realprice: prods.realprice,
                appliesto: prods.promo.appliesto,
                description: prods.promo.description,
                price: prods.promo.price,
                type: prods.promo.type,
                promocode: prods.promocode,
              },
            });
          }
        }
      });
    }
  }, [serverProductsGroup, serverProduct.pid, priceByTermin, termin]);

  useEffect(() => {
    switch (termin) {
      case "triennially":
        setPriceByTermin(serverProduct.price.triennially);
        break;
      case "biennially":
        setPriceByTermin(serverProduct.price.biennially);
        break;
      case "annually":
        setPriceByTermin(serverProduct.price.annually);
        break;
      case "quarterly":
        setPriceByTermin(serverProduct.price.quarterly);
        break;
      case "semiannually":
        setPriceByTermin(serverProduct.price.semiannually);
        break;
      case "monthly":
        setPriceByTermin(serverProduct.price.monthly);
        break;
      default:
        setPriceByTermin(0);
        break;
    }
  }, [serverProduct, termin]);

  const changeOperatingSystemHandler = (e) => {
    const selectedValue = e.target.value;
    
    if (selectedValue === "choose") {
      setCurrentOS(0);
      return;
    }

    const selectedOS = addonsServer.find(addon => addon.id === parseInt(selectedValue));
    if (selectedOS) {
      setCurrentOS(selectedOS);
      setServerProduct({ type: "SET_OS", payload: { os: selectedOS } });
    }
  };

  const changeTerminHandler = (e) => {
    const terminValue = e.target.value;
    setTermin(terminValue);

    const notIncludePID = [
      "1010",
      "1024",
      "1031",
      "1038",
      "1045",
      "1052",
      "1059",
      "1066",
    ];
    const startDate = new Date("2024-08-17T07:00:00+07:00");
    const endDate = new Date("2024-08-25T07:00:00+07:00");
    const currentDate = new Date();

    const isWithinPromoPeriod =
      currentDate >= startDate && currentDate < endDate;

    const shouldApplyPromo =
      activeGID !== 5 &&
      activeGID !== 708 &&
      activeGID !== 709 &&
      activeGID !== 712 &&
      activeGID !== 721 &&
      !notIncludePID.includes(query.pid) &&
      location.pathname !== "/paymentmethod" &&
      location.pathname !== "/orderesummary" &&
      !query.promocode &&
      isWithinPromoPeriod;

    if (shouldApplyPromo) {
      dispatch(
        getProductsPromoServer({
          gid: activeGID,
          pid: serverProduct.serverDetails.pid,
          billingcycle: terminValue,
          promocode: "DISKON45",
        })
      );
    }

    setTimeout(() => {
      if (currentOS)
        setServerProduct({ type: "SET_OS", payload: { os: currentOS } });
    }, 100);
    setTimeout(() => {
      if (currentPanel)
        dispatch(addVpsAddons({ pid: serverProduct.pid, addons: currentPanel }));
      if (currentBackup)
        dispatch(addVpsAddons({ pid: serverProduct.pid, addons: currentBackup }));
      if (currentSupport)
        dispatch(addVpsAddons({ pid: serverProduct.pid, addons: currentSupport }));
      if (currentSoftaculous)
        dispatch(
          addVpsAddons({ pid: serverProduct.pid, addons: currentSoftaculous })
        );
      if (currentOthers)
        dispatch(addVpsAddons({ pid: serverProduct.pid, addons: currentOthers }));
    }, 200);
  };

  const changePasswordHandler = () => {
    const password = passwordRef?.current?.value;
    const {
      title = null,
      score = 0,
      variant,
    } = checkPasswordStrength(password) ?? {};
    setPasswordStrength({ title, variant, score: score * 20 });
  };

  const toggleVisibilityHandler = () => {
    if (passwordRef.current.type === "password") {
      passwordRef.current.type = "text";
      peekIconRef.current.src = NoPeek;
    } else {
      passwordRef.current.type = "password";
      peekIconRef.current.src = Peek;
    }
  };



  useEffect(() => {
    if (serverProduct && serverProduct.serverDetails) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  }, [serverProduct]);

  const addToCartHandler = useCallback(() => {
    // Basic validation checks
    if (!serverProduct || !serverProduct.serverDetails) {
      notifyWarning("Produk belum siap, silahkan tunggu sebentar.");
      return;
    }

    if (!hostnameRef.current?.value || !passwordRef.current?.value) {
      notifyWarning("Silahkan isi hostname dan password terlebih dahulu.");
      return;
    }

    if (passwordStrength.score < 40) {
      notifyError("Password anda terlalu lemah, coba lagi!");
      return;
    }

    // Check OS requirement
    if (!currentOS) {
      notifyWarning("Silahkan pilih OS (Operating System) terlebih dahulu.");
      return;
    }

    // Prepare Server details
    const hostname = hostnameRef.current.value;
    const password = passwordRef.current.value;

    setServerProduct({
      type: "SET_HOSTNAME_PASSWORD",
      payload: { hostname, password }
    });

    const updatedServerDetails = {
      ...serverProduct.serverDetails,
      hostname,
      password
    };

    // Process if product is ready
    if (currentProduct.status === "idle" && serverProduct.serverDetails) {
      // Get OS details and price
      const getOS = serverProduct.serverDetails.serveraddons?.find(
        (addons) => addons.input_name === "Operating System"
      );

      const getOsPrice = getOS ? (+getOS[termin] === -1 ? 0 : +getOS[termin]) : 0;

      // Process custom fields
      let valueCustomfield = "";
      if (getOS) {
        const operatingSystemFields = activeProd.customfields.customfield.filter(
          (field) => field.name === "OS"
        );
        
        if (operatingSystemFields.length > 0) {
          valueCustomfield = {
            id: operatingSystemFields[0].id,
            value: getOS.name
          };
        }
      }

      // Add promo if applicable
      if (serverProduct.promo && serverProduct.serverDetails.pid === serverProduct.promo.pid) {
        dispatch(addPromo(serverProduct.promo));
      }
      
      // Check if product already exists in cart
      const existingProduct = productsList.find(product => product.pid === serverProduct.serverDetails.pid);
      
      // Prepare customfields - preserve existing ones and add OS if needed
      let customfields = [];
      if (existingProduct && existingProduct.customfields) {
        customfields = [...existingProduct.customfields];
        
        // Remove existing OS customfield if it exists
        customfields = customfields.filter(field => {
          const osField = activeProd.customfields.customfield.find(f => f.name === "OS");
          return !osField || field.id !== osField.id;
        });
      }
      
      // Add OS customfield if it exists
      if (valueCustomfield) {
        customfields.push(valueCustomfield);
      }
      
      const productData = {
        ...updatedServerDetails,
        priceWithAddon: getOsPrice + serverProduct.serverDetails.price,
        configoptions: existingProduct?.configoptions || [],
        customfields: customfields,
        vpsaddons: getOS ? [getOS] : [] // Add OS to vpsaddons so it shows in checkout table
      };

      if (existingProduct) {
        // Update existing product to preserve addons
        dispatch(changeProductFromCart(productData));
        notifySuccess("Produk berhasil diperbarui di keranjang.");
      } else {
        // Add new product
        dispatch(addToCart(productData));
        notifySuccess("Produk berhasil ditambahkan ke keranjang. Silahkan pilih addons yang anda butuhkan.");
      }
    }
  }, [
    serverProduct,
    currentProduct.status,
    hostnameRef,
    passwordRef,
    passwordStrength.score,
    termin,
    currentOS,
    activeProd.customfields,
    productsList,
    dispatch
  ]);







  useEffect(() => {
    const notIncludePID = [
      "1010", "1024", "1031", "1038", "1045", "1052", "1059", "1066"
    ];
    const startDate = new Date("2024-08-17T07:00:00+07:00");
    const endDate = new Date("2024-08-25T07:00:00+07:00");
    const currentDate = new Date();
    const isWithinPromoPeriod = currentDate >= startDate && currentDate < endDate;

    const shouldApplyPromo =
      activeGID !== 5 &&
      activeGID !== 708 &&
      activeGID !== 709 &&
      activeGID !== 712 &&
      activeGID !== 721 &&
      !notIncludePID.includes(query.pid) &&
      location.pathname !== "/paymentmethod" &&
      location.pathname !== "/orderesummary" &&
      !query.promocode &&
      isWithinPromoPeriod;

    if (shouldApplyPromo) {
      if (query.pid) {
        setShowPromo(true);
        dispatch(setQueryPromo("DISKON45"));
        dispatch(getProductsPromoServer({
          gid: activeGID,
          pid: query.pid,
          billingcycle: query.billingcycle,
          promocode: "DISKON45",
        }));
      } else if (serverProduct?.serverDetails?.pid !== serverProduct?.promo?.pid) {
        dispatch(setQueryPromo("DISKON45"));
        dispatch(getProductsPromoServer({
          gid: activeGID,
          pid: serverProduct?.serverDetails?.pid,
          billingcycle: termin,
          promocode: "DISKON45",
        }));
      }
    } else if (query.promocode) {
      dispatch(setQueryPromo(query.promocode));
    } else {
      dispatch(setQueryPromo(null));
      dispatch(removePromoCode());
    }
  }, [
    activeGID,
    query.pid,
    query.billingcycle,
    query.promocode,
    location.pathname,
    serverProduct?.serverDetails?.pid,
    serverProduct?.promo?.pid,
    termin,
    dispatch
  ]);

  useEffect(() => {
    if (currentProduct.status === "idle" && serverProduct?.serverDetails && productsList.length > 0) {
      const updatedServerDetails = {
        ...serverProduct.serverDetails,
        hostname: hostnameRef.current?.value,
        password: passwordRef.current?.value,
      };

      let getOsPrice = 0;
      let valueCustomfield = "";

      // Use currentOS if available, otherwise fallback to serveraddons
      const getOS = currentOS || serverProduct.serverDetails.serveraddons?.find(
        (addons) => addons.input_name === "Operating System"
      );

      if (getOS) {
        getOsPrice = getOS && +getOS[termin] === -1 ? 0 : +getOS[termin];
        const operatingSystemFields = activeProd.customfields.customfield.filter(
          (field) => field.name === "OS"
        );
        if (operatingSystemFields.length > 0) {
          valueCustomfield = { 
            id: operatingSystemFields[0].id, 
            value: getOS.name 
          };
        }
      }

      if (serverProduct.promo && 
          serverProduct.serverDetails.pid === serverProduct.promo.pid && 
          productsList.length > 0) {
        dispatch(addPromo(serverProduct.promo));
      }

      // Get existing product to preserve addons
      const existingProduct = productsList.find(product => product.pid === serverProduct.serverDetails.pid);
      
      // Prepare customfields - preserve existing ones and add OS if needed
      let customfields = [];
      if (existingProduct && existingProduct.customfields) {
        customfields = [...existingProduct.customfields];
        
        // Remove existing OS customfield if it exists
        customfields = customfields.filter(field => {
          const osField = activeProd.customfields.customfield.find(f => f.name === "OS");
          return !osField || field.id !== osField.id;
        });
      }
      
      // Add OS customfield if it exists
      if (valueCustomfield) {
        customfields.push(valueCustomfield);
      }

      dispatch(changeProductFromCart({
        ...updatedServerDetails,
        priceWithAddon: getOsPrice + serverProduct.serverDetails.price,
        configoptions: existingProduct?.configoptions || [],
        customfields: customfields,
        vpsaddons: getOS ? [getOS] : [] // Add OS to vpsaddons so it shows in checkout table
      }));
    }
  }, [
    currentProduct.status,
    serverProduct?.serverDetails,
    serverProduct?.promo,
    productsList.length,
    termin,
    activeProd.customfields,
    hostnameRef,
    passwordRef,
    currentOS, // Add currentOS to dependencies so cart updates when OS changes
    dispatch
  ]);

  // const resetProductSelection = (serverId) => {
  //   if (serverId === "725") { // USA server ID
  //     setProdsValue("SC2");
  //   } else {
  //     setProdsValue(vpsProductInit[0].value);
  //   }
  //   setBundleValue({ forLabel: "", forValue: "empty" });
  //   setCurrentPanel(false);
  //   setCurrentSupport(false);
  //   setCurrentSoftaculous(false);
  //   setCurrentOthers(false);
  //   setCurrentBackup(false);
  //   setBundlePromo("choose");
  //   setCurrentBundlingPanel(0);
  //   setCurrentOSBundle(0);
  // };

  const hasAvailableAddons = () => {
    return (
      checkControlPanel.length !== 0 ||
      checkSupportLevel.length !== 0 ||
      checkAdvancedBackup.length !== 0 ||
      checkOthers.length !== 0
    );
  };

  return (
    <MainLayouts summary={false}>
      <ServerOptions
        setServer={setServer}
        server={server}
        currentProdName={currentProdName}
      />
      <CardWrapper title="Order Server">
        <div className="align-items-center">
          <div className="row">
            <div className="col-12 col-md-8">
                {serverProductsGroup.length === 0 ? (
                  <Placeholder as="h3" animation="glow">
                    <Placeholder bg="danger" xs={6} />
                  </Placeholder>
                ) : (
                  <h3 className="text-qw-primary mb-0">{currentProdName}</h3>
                )}
            </div>
            <div className="col-12 col-md-4 text-md-end text-start mt-1">
              {serverProductsGroup.length === 0 ? (
                <Placeholder as="h5" animation="glow">
                  <Placeholder xs={6} />
                </Placeholder>
              ) : (
                <>
                  {serverProduct.promo?.realprice &&
                    serverProduct.serverDetails.pid === serverProduct.promo.pid && (
                      <s className="text-secondary me-2">
                        {formatIDR(serverProduct.promo.realprice)}
                      </s>
                    )}
                  <h5 className="fw-bold mb-0">{formatIDR(priceByTermin)}</h5>
                </>
              )}
            </div>
          </div>
          <BillingCycleOptions
            termin={termin}
            terminHandle={changeTerminHandler}
            productsItem={serverProduct}
          />
          <div className="row">
            <div className="col-12 col-md-6 mt-3">
              <label htmlFor="hostname" className="fw-bold mb-3">
                Hostname
              </label>
              <input
                type="text"
                className="form-control"
                id="hostname"
                name="hostname"
                ref={hostnameRef}
              />
            </div>
            <div className="col-12 col-md-6 mt-3">
              <label htmlFor="password" className="fw-bold mb-3">
                Password
              </label>
              <div className="position-relative">
                <input
                  type="password"
                  className="form-control"
                  style={{ paddingRight: "15px" }}
                  id="password"
                  name="password"
                  ref={passwordRef}
                  onChange={changePasswordHandler}
                />
                <button
                  className="btn btn-link position-absolute"
                  style={{ right: "2%", top: "15%", padding: "0", margin: "0" }}
                  type="button"
                  onClick={toggleVisibilityHandler}
                >
                  <img ref={peekIconRef} src={Peek} alt="peek.svg" />
                </button>
              </div>
              {passwordStrength.score !== 0 && (
                <div className="mt-2">
                  <ProgressBar
                    variant={passwordStrength.variant}
                    now={passwordStrength.score}
                  />
                  <div
                    className={`text-${passwordStrength.variant} fw-bold small`}
                  >
                    {passwordStrength.title}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="col-12 mt-3">
            <label htmlFor="operatingSystem" className="fw-bold mb-3">
              Pilih Sistem Operasi
            </label>
            <select
              name="operatingSystem"
              id="operatingSystem"
              className="form-select"
              onChange={changeOperatingSystemHandler}
              value={currentOS ? currentOS.id : "choose"}
            >
              <option value="choose">Pilih Sistem Operasi</option>
              {addonsServer
                .filter(addon => addon.input_name === "Operating System")
                .map((os) => (
                  <option value={os.id} key={os.id}>
                    {os.name.split(" - ")[1]}
                  </option>
                ))}
            </select>
          </div>
          {showPromo && serverProduct && (
            <PromoKaosTumbler
              price={total}
              billingcycle={termin}
            />
          )}
          <AddToCartButton
            onClick={addToCartHandler}
            disabled={isButtonDisabled}
          />
        </div>
      </CardWrapper>
      <div ref={addonsRef}>
        {productsList && 
         productsList.length !== 0 && 
         hasAvailableAddons() && (
          <CardWrapper title="Addons Server (Opsional)">
            {checkControlPanel.length !== 0 && (
              <AddonsVPSDropdown
                label="Control Panel"
                optionData={addonsServer}
                setCurrentPanel={setCurrentPanel}
              />
            )}
            {checkSupportLevel.length !== 0 && (
              <AddonsVPSDropdown
                label="Support Level"
                optionData={addonsServer}
                setCurrentSupport={setCurrentSupport}
              />
            )}
            {checkAdvancedBackup.length !== 0 && (
              <AddonsVPSDropdown
                label="Advanced Backup"
                optionData={addonsServer}
                setCurrentBackup={setCurrentBackup}
              />
            )}
            {checkOthers.length !== 0 && (
              <AddonsVPSDropdown
                label="Others"
                optionData={addonsServer}
                setCurrentOthers={setCurrentOthers}
              />
            )}
          </CardWrapper>
        )}
      </div>
    </MainLayouts>
  );
};

const CollapseIcon = (props) => {
  return (
    <img
      {...props}
      src={collapseIcon}
      alt="icon.png"
      height={"auto"}
      width={12}
    />
  );
};

export default Server;